import {
  Streaming_StreamSource,
  Streaming_StreamSource_Resolution,
} from 'lib/generated/proto/roboverse_platform_protos/statekeeping/Reported/Streaming';

export enum DefaultCameraSource {
  OFF = 'Off',
  // keep in mind, this is hardcoded data and in the future it should be fetched from the server
  SpotCamStream = 'SpotCam',
  GripperCam = 'Gripper',
}

// default item for camera source selector
export const CameraSourceOffItem: CameraSource = {
  value: DefaultCameraSource.OFF,
  label: DefaultCameraSource.OFF,
};

// old - but used as a reduced version of StreamSource
export type CameraSource = {
  value: string;
  label: string;
};

export type StreamSource = Streaming_StreamSource & {
  spotServiceName?: 'image' | 'spot-cam-image' | string;
  // note: the loading function of this data is add a proper fallback
  nativeResolution: Streaming_StreamSource_Resolution;
};

export type StreamSourceName = StreamSource['name'];
